'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPeopleOutline = function MdPeopleOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 10.9c-1.8 0-3.4 1.4-3.4 3.2s1.6 3.4 3.4 3.4 3.4-1.6 3.4-3.4-1.6-3.2-3.4-3.2z m0 9.1c-3.2 0-5.9-2.7-5.9-5.9s2.7-5.7 5.9-5.7 5.9 2.5 5.9 5.7-2.7 5.9-5.9 5.9z m-15-9.1c-1.8 0-3.4 1.4-3.4 3.2s1.6 3.4 3.4 3.4 3.4-1.6 3.4-3.4-1.6-3.2-3.4-3.2z m0 9.1c-3.2 0-5.9-2.7-5.9-5.9s2.7-5.7 5.9-5.7 5.9 2.5 5.9 5.7-2.7 5.9-5.9 5.9z m23.4 9.1v-2c0-0.9-4.3-3-8.4-3-1.8 0-3.5 0.5-5 1 0.5 0.6 0.9 1.2 0.9 2v2h12.5z m-15 0v-2c0-0.9-4.3-3-8.4-3s-8.4 2.1-8.4 3v2h16.8z m6.6-7.5c3.6 0 10.9 1.9 10.9 5.5v4.5h-36.8v-4.5c0-3.6 7.3-5.5 10.9-5.5 2 0 5.1 0.7 7.5 1.8 2.4-1.1 5.5-1.8 7.5-1.8z' })
        )
    );
};

exports.default = MdPeopleOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/people-outline.js
// module id = 3620
// module chunks = 168707334958949